import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PostAddIcon from "@mui/icons-material/PostAdd";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { formatDate } from "../../../utils/dateFormat";
import axios from "axios";

const List = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [customers, setCustomers] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.state && location.state.message) {
      toast.success(location.state.message);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, navigate]);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/getAllCustomers`);
      if (response.status === 200) {
        setLoading(false);
        setCustomers(response.data.customers);
      } else {
        toast.success("Failed to fetch customers.");
        setLoading(true);
      }
    } catch (error) {
      setLoading(true);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(`Error: ${error.response.data.message}`);
      } else {
        toast.error("An error occurred. Please try again later.");
      }
    }
  };
  React.useEffect(() => {
    fetchCustomers();
  }, []);

  return (
    <div className="dashboard-content-wrap p-10">
      <ToastContainer />
      <div className="box-card">
        <div className="box-card-title mb-4">
          <h1 className="text-lg font-medium flex items-center">
            AGA Customers
          </h1>
        </div>
        <div className="box-card-body">
          {loading ? (
            <p className="text-sm mt-5">Loading customers...</p>
          ) : customers.length > 0 ? (
            customers.map((customer) => (
              <div className="customer-card" key={customer._id}>
                <h1>{customer?.name}</h1>
                <p>{customer?.email}</p>
                <p>{customer?.phone}</p>
                <span>{formatDate(customer?.createdAt)}</span>
              </div>
            ))
          ) : (
            <p>No customers found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default List;
